var map = {
	"./act": 1497,
	"./act.ts": 1497,
	"./gmat": 1498,
	"./gmat.ts": 1498,
	"./gre": 1499,
	"./gre.ts": 1499,
	"./ielts": 1500,
	"./ielts.ts": 1500,
	"./ielts_general_training": 1501,
	"./ielts_general_training.ts": 1501,
	"./lsat": 1502,
	"./lsat.ts": 1502,
	"./mcat": 1503,
	"./mcat.ts": 1503,
	"./sat": 1504,
	"./sat.ts": 1504,
	"./toefl": 1505,
	"./toefl.ts": 1505
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2510;
module.exports = webpackAsyncContext;